interface ContextProps {
  children: React.ReactNode;
}

export const Context: React.FC<ContextProps> = ({ children }) => (
  <>{children}</>
);
